import { Button, Col, Form, Input, Row, Select, Checkbox, Spin, TimePicker, DatePicker, InputNumber, Upload, message } from "antd";
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import TextArea from "antd/lib/input/TextArea";
import { createFranchise, getFranchiseById, updateFranchise } from "../../redux/rtk/features/franchise/franchiseSlice";
import { getAllGames } from "../../redux/rtk/features/game/gameSlice";
import 'antd/dist/antd.css';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { handleError } from "../../utils/ErrorHandler";
import { toast } from "react-toastify";
import { addHoliday, getAllHolidays, updateHoliday } from "../../redux/rtk/features/holiday/holidaySlice";
import { getAWSImage } from "../../redux/rtk/features/user/userSlice";
import ImageCropper from '../ImageCropper/ImageCropper';
import { UploadOutlined } from '@ant-design/icons';

dayjs.extend(customParseFormat);
const getCroppedImg = (imageSrc, crop) => {

  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.src = imageSrc;

    if (imageSrc.startsWith('blob:')) {
      image.crossOrigin = null;
    }

    image.onload = () => {
      const canvas = document.createElement('canvas');
      const scaleX = image.naturalWidth / image.width;
      const scaleY = image.naturalHeight / image.height;
      canvas.width = crop.width;
      canvas.height = crop.height;
      const ctx = canvas.getContext('2d');


      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
      );

      try {
        canvas.toBlob((blob) => {
          if (!blob) {
            console.error('Blob conversion failed');
            reject(new Error('Canvas to Blob conversion failed'));
            return;
          }
          const croppedUrl = URL.createObjectURL(blob);
          resolve(croppedUrl);
        }, 'image/jpeg', 0.95);
      } catch (error) {
        console.error('Error in blob conversion:', error);
        reject(error);
      }
    };

    image.onerror = (error) => {
      console.error('Image loading error:', error);
      reject(error);
    };
  });
};

function FranchiseForm({ setFranchiseSettings, error, setError, setIsFormChanged, current, setCurrent, userId, setUserId, setSelectedGames, selectedGames, setMaxPlayers }) {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState('');
  const [gamesData, setGamesData] = useState([])
  const [holidays, setHolidays] = useState([])
  const [holidayDates, setHolidayDates] = useState(null);
  const [currentHoliday, setCurrentHoliday] = useState(null);
  const [currentGames, setCurrentGames] = useState([])
  const [isEditing, setIsEditing] = useState(false);
  const [stepOneData, setStepOneData] = useState({});
  const [isSavingForm, setIsSavingForm] = useState(false);
  const [isSubmittingForm, setIsSubmittingForm] = useState(false);
  const { isFetchingSingle, isSubmitting } = useSelector((state) => state.franchise);
  const [originalImageUrl, setOriginalImageUrl] = useState('');

  const { Option } = Select;

  const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  const [weekDays, setWeekDays] = useState(["Tuesday", "Wednesday", "Thursday", "Friday"]);
  const [weekEndDays, setWeekEndDays] = useState(["Saturday", "Sunday"]);
  const [weekOffDays, setWeekOffDays] = useState(["Monday"]);

  const [openTime, setOpenTime] = useState(dayjs('10:00', 'HH:mm'));
  const [closeTime, setCloseTime] = useState(dayjs('21:00', 'HH:mm'));
  const [weekendOpenTime, setWeekendOpenTime] = useState(dayjs('10:00', 'HH:mm'));
  const [weekendCloseTime, setWeekendCloseTime] = useState(dayjs('21:00', 'HH:mm'));


  const checkHolidayChanges = () => {
    if (holidayDates)
      if (currentHoliday && holidayDates) {
        // Check if dates are different
        if (dayjs(currentHoliday?.startDate).format('YYYY-MM-DD') !== dayjs(holidayDates?.[0]).format('YYYY-MM-DD') || dayjs(currentHoliday?.endDate).format('YYYY-MM-DD') !== dayjs(holidayDates?.[1]).format('YYYY-MM-DD')) {
          // Dates changed, make update API call
          updateHolidayDates(currentHoliday.id);
        }
      } else if (!currentHoliday && holidayDates) {
        // No existing holiday but new dates selected
        addHolidayDates();
      }
  }


  // Go to second tab
  const handleNext = async () => {
    try {
      const values = await form.validateFields();
      if (!openTime || !closeTime || !weekendOpenTime || !weekendCloseTime) {
        toast.error("Please select franchise open and close time")
        return;
      }
      // making api call to holiday api if have values
      if (error) {
        toast.error(error)
        return;
      }
      checkHolidayChanges();
      setStepOneData(values);
      setCurrent(current + 1);
    } catch (error) {
      console.error("Form validation failed:", error);
      // Get the first error field
      const firstErrorField = error.errorFields?.[0];
      if (firstErrorField) {
        // Find the form item element by its name
        const errorElement = document.getElementById(`basic_${firstErrorField.name[0]}`);
        console.log("errorElement", errorElement, firstErrorField.name[0])
        if (errorElement) {
          // Scroll to the error field with smooth behavior
          errorElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }
    }
  };
  const handleImageChange = (event) => {
    if (event.target.files[0]) {
      setImage(event.target.files[0]);
      const reader = new FileReader();
      reader.onload = (e) => {
        setImageUrl(e.target.result);
        setShowCropper(true);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const onFinish = async (callback) => {
    try {
      if (error){
        toast.error(error)
        return
      }
      const values = await form.validateFields();
      if (!openTime || !closeTime || !weekendOpenTime || !weekendCloseTime) {
        toast.error("Please select franchise open and close time")
        return;
      }
      const formData = new FormData();
      const finalValues = {
        ...stepOneData, ...values, weekDays: weekDays.join(","), weekendDays: weekEndDays.join(","), weekOffDay: weekOffDays.join(","), openingTime: openTime ? openTime.format('hh:mm A') : null, closingTime: closeTime ? closeTime.format('hh:mm A') : null, weekendopeningTime: weekendOpenTime ? weekendOpenTime.format('hh:mm A') : null, weekendclosingTime: weekendCloseTime ? weekendCloseTime.format('hh:mm A') : null
      };
      setStepOneData(finalValues)
      setMaxPlayers(finalValues.maxPlayers)
      Object.entries(finalValues).forEach(([key, value]) => {
        if (key == "productId")
          formData.append('productId', value.join(","));
        else if (key == "franchiseImage")
          formData.append('franchiseImage', image || value);
        else
          formData.append(key, (value == undefined ? "" : value));
      });
      formData.append("password", " ")
      if (isEditing) {
        formData.delete('roleId')
        const data = await dispatch(updateFranchise({ id: userId, formData: formData })).unwrap();
        const newSelectedGames = data.franchise.product.map(product => {
          const game = gamesData.find(g => g.id === product.productId)
          // return { franchiseName: data.franchise.franchiseName, gameName: game.gameName, ...product }
          return { franchiseName: data.franchise.franchiseName, franchiseId: data.franchise.id, gameName: game.gameName, gameResetTime: game.gameResetTime, gamePlayTime: game.gamePlayTime, id: product.productId }
        })



        setFranchiseSettings({
          openingTime: data.franchise.openingTime,
          closingTime: data.franchise.closingTime
        })
        setSelectedGames(newSelectedGames)
        setIsFormChanged({
          submitFunction: null,
          state: false
        })
        callback() // This is callback function to change tab
      }
      else {
        // This is franchise role id
        formData.append('roleId', '4');
        const data = await dispatch(createFranchise(formData)).unwrap();
        setUserId(data.id)
        const selectedGames = data.product.map(product => {
          const game = gamesData.find(g => g.id === product.productId)
          return { franchiseName: data.franchiseName, franchiseId: data.id, gameName: game.gameName, gameResetTime: game.gameResetTime, gamePlayTime: game.gamePlayTime, id: product.productId }
        })

        setSelectedGames(selectedGames)
        setFranchiseSettings({
          openingTime: data.openingTime,
          closingTime: data.closingTime
        })
        setIsFormChanged({
          submitFunction: null,
          state: false
        })
        setIsEditing(true)
        callback() // This is callback function to change tab
      }
    } catch (error) {
      console.error(error)
      if (error?.errorFields?.[0]?.name?.[0] == "productId") {
        setCurrent(1);
      } else {
        setCurrent(0);
      }
      // Check if error is a validation error
      if (error?.errorFields) {
        toast.error("Please fill all the required fields");
        throw new Error("Please fill all the required fields");
      }

    }

  };

  async function getGamesData() {
    const games = await dispatch(getAllGames()).unwrap();
    setGamesData(games)
  }
  const setEditFormValues = async (id) => {
    try {

      const formData = await dispatch(getFranchiseById(id)).unwrap();
      form.setFieldsValue({
        ...formData,
        productId: formData.product.map(data => data.productId),
        weekDays: formData.weekDays.split(","),
        weekendDays: formData.weekendDays.split(","),
        weekOffDay: formData.weekOffDay.split(",").filter(day => day !== "")
      })
      // set holiday values 
      const holidayDate = formData?.holiday[0];
      if (holidayDate) {
        setHolidayDates([dayjs(holidayDate.startDate), dayjs(holidayDate.endDate)])
        setCurrentHoliday(holidayDate)
      }
      // get franchise image 
      const franchiseImage = await dispatch(getAWSImage(formData.franchiseImage)).unwrap();
      setImageUrl(franchiseImage.url)
      setOriginalImageUrl(franchiseImage.url)

      setStepOneData({ ...formData, productId: formData.product.map(item => item.product.id) })
      const selectedGames = formData.product.map(item => {
        return { franchiseName: formData.franchiseName, franchiseId: formData.id, gameName: item.product.gameName, gameResetTime: item.product.gameResetTime, gamePlayTime: item.product.gamePlayTime, id: item.product.id }

      })
      // set week days
      setWeekDays(formData.weekDays.split(","))
      setWeekEndDays(formData.weekendDays.split(","))
      setWeekOffDays(formData.weekOffDay.split(",").filter(day => day !== ""))

      setOpenTime(dayjs(formData.openingTime, 'hh:mm A'))
      setCloseTime(dayjs(formData.closingTime, 'hh:mm A'))
      setWeekendOpenTime(dayjs(formData.weekendopeningTime, 'hh:mm A'))
      setWeekendCloseTime(dayjs(formData.weekendclosingTime, 'hh:mm A'))
      setFranchiseSettings({
        openingTime: formData.openingTime,
        closingTime: formData.closingTime
      })
      setSelectedGames(selectedGames)
      setCurrentGames(selectedGames)

      const holidays = await dispatch(getAllHolidays(id)).unwrap();
      if (holidays?.holidayList?.length) {
        const formattedHolidays = holidays?.holidayList?.map(holiday => ({
          id: holiday.id,
          franchiseId: holiday.franchiseId,
          startDate: holiday.startDate,
          endDate: holiday.endDate,
          note: holiday.note,
          user: {
            id: holiday.user.id,
            franchiseName: holiday.user.franchiseName
          }
        }))
        setHolidays(formattedHolidays)
      }
    } catch (error) {
      handleError(error)
    }

  }
  useEffect(() => {
    if (id) {
      setEditFormValues(id)
      setUserId(id)
      setIsEditing(true)
    }
    getGamesData();
  }, [dispatch]);


  // for time picker 
  const [timeValue, setTimeValue] = useState(null);

  const handleTimeChange = (time, timeString) => {
    setTimeValue(timeString); // Store the selected time string
  };

  const handleWeekDaysSelectChange = (value) => {
    setWeekDays(value);
    form.setFieldsValue({
      weekDays: value
    })
    // Clear second and third selects when the first changes
    setWeekEndDays([]);
    form.setFieldsValue({
      weekendDays: []
    })
    setWeekOffDays([]);
    form.setFieldsValue({
      weekOffDay: []
    })
    setIsFormChanged({
      submitFunction: onFinish,
      state: true
    })
  };

  const handleWeekEndDaysSelectChange = (value) => {
    setWeekEndDays(value);
    form.setFieldsValue({
      weekendDays: value
    })
    // Clear third select when the second changes
    setWeekOffDays([]);
    form.setFieldsValue({
      weekOffDay: []
    })
    setIsFormChanged({
      submitFunction: onFinish,
      state: true
    })
  };

  const handleWeekOffDaysSelectChange = (value) => {
    setWeekOffDays(value);
    form.setFieldsValue({
      weekOffDay: value
    })
    setIsFormChanged({
      submitFunction: onFinish,
      state: true
    })
  };

  useEffect(() => {
    // check if week days, weekend days, week off days contains all 7 days 
    const selectedDays = [...weekDays, ...weekEndDays, ...weekOffDays];
    if (selectedDays.length !== 7) {
      setError("Please select all 7 days");
    }
    else if (!openTime || !closeTime || !weekendOpenTime || !weekendCloseTime) {
      setError("Please select franchise open and close time")
    }
    else {
      setError(null)
    }
  }, [weekDays, weekEndDays, weekOffDays, openTime, closeTime, weekendOpenTime, weekendCloseTime])



  // Get the remaining days for each dropdown
  const getRemainingDays = (excludeDays) => {
    return daysOfWeek.filter((day) => !excludeDays.includes(day));
  };

  const handleStartTimeChange = (time) => {
    setOpenTime(time);
    setIsFormChanged({
      submitFunction: onFinish,
      state: true
    })
  };

  const handleEndTimeChange = (time) => {
    setCloseTime(time);
    setIsFormChanged({
      submitFunction: onFinish,
      state: true
    })
  };
  
  const handleWeekendOpenTimeChange = (time) => {
    setWeekendOpenTime(time);
    setIsFormChanged({
      submitFunction: onFinish,
      state: true
    })
  };

  const handleWeekendCloseTimeChange = (time) => {
    setWeekendCloseTime(time);
    setIsFormChanged({
      submitFunction: onFinish,
      state: true
    })
  };

  const addHolidayDates = async () => {
    try {
      if (holidayDates && id || userId) {
        const payload = {
          "franchiseId": parseInt(id || userId), // Changed from franchiseId to userId based on schema
          "startDate": holidayDates[0],
          "endDate": holidayDates[1],
          "note": "Test comment",
        }
        const data = await dispatch(addHoliday(payload)).unwrap();
      }
      else {
        if (!id)
          toast.error("Invalid franchise")
        else
          toast.error("Please select holiday dates")
      }
    } catch (error) {
      console.error(error)
    }
  }
  const updateHolidayDates = async (holidayId) => {
    try {
      if (holidayDates && id || userId) {
        const payload = {
          "franchiseId": parseInt(id || userId), // Changed from franchiseId to userId based on schema
          "startDate": holidayDates[0],
          "endDate": holidayDates[1],
          "note": "Test comment",
        }
        const data = await dispatch(updateHoliday({ id: holidayId, values: payload })).unwrap();
      }
      else {
        if (!id)
          toast.error("Invalid franchise")
        else
          toast.error("Please select holiday dates")
      }
    } catch (error) {
      console.error(error)
    }
  }


  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [showCropper, setShowCropper] = useState(false);



  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const cropImage = async () => {
    try {

      const croppedImage = await getCroppedImg(imageUrl, croppedAreaPixels);

      // Convert blob URL to File object for backend upload
      const response = await fetch(croppedImage);

      const blob = await response.blob();

      const file = new File([blob], 'cropped_image.jpg', { type: 'image/jpeg' });

      setImage(file); // Save File object for backend upload
      setImageUrl(croppedImage); // Save URL for preview
      setShowCropper(false);

    } catch (e) {
      console.error('Error in cropImage:', e);
      console.error('Error details:', {
        message: e.message,
        stack: e.stack
      });
    }
  };
  return (
    <>
      <Form
        size='small'
        form={form}
        name='basic'
        labelCol={{
          span: 22,
        }}
        wrapperCol={{
          span: 22,
        }}
        initialValues={{
          remember: true,
          franchiseStatus: "Active",
          weekDays: ["Tuesday", "Wednesday", "Thursday", "Friday"],
          weekendDays: ["Saturday", "Sunday"],
          weekOffDay: ["Monday"]
        }}
        autoComplete='off'
        className="franchise-form"
        onFieldsChange={() => setIsFormChanged({
          submitFunction: onFinish,
          state: true
        })}
      >
        {current === 0 && (

          <div className='mr-top mb-4 px-6 pb-6 pt-4 ant-card franchise-card border-radius-bottom' style={{ maxWidth: "100%" }}>

            {isFetchingSingle ? <Spin size={"medium"} className="flex items-center justify-center min-h-[60vh] text-danger" /> :
              <>
                <Row
                  gutter={{
                    xs: 8,
                    sm: 16,
                    md: 24,
                    lg: 32,
                  }}
                  className="justify-between"
                >

                  <Col span={24} className='gutter-row form-color'>
                    <h2 className='text-xl mt-3 mb-5 text-danger hover:text-dangerHover font-semibold'>
                      <span className="pb-1 border-b-2 border-danger inline-block"> Franchise Information</span>
                    </h2>
                    <Row
                      gutter={{
                        xs: 8,
                        sm: 16,
                        md: 24,
                        lg: 32,
                      }}
                    >
                      <Col xs={24} lg={12} className='gutter-row'>
                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='Franchise Name'
                          name='franchiseName'
                          className="form-item-alignment"
                          rules={[
                            {
                              required: true,
                              message: "Please input Franchise Name!",
                            },
                            {
                              pattern: /^[^\s].*[^\s]$/,
                              message: "Franchise name cannot start or end with spaces",
                            },
                            // {
                            //   pattern: /^[a-zA-Z0-9\s]*$/,
                            //   message: "Franchise name cannot contain special characters",
                            // },
                            {
                              min: 3,
                              message: "Franchise name must be at least 3 characters",
                            }
                          ]}
                        >
                          <Input placeholder='Franchise' />
                        </Form.Item>
                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='Franchise Owner Name'
                          name='ownerName'
                          className="form-item-alignment"
                          rules={[
                            {
                              required: true,
                              message: "Please input Owner Name!",
                            },
                            {
                              pattern: /^[^\s].*[^\s]$/,
                              message: "Owner name cannot start or end with spaces",
                            },
                            {
                              pattern: /^[a-zA-Z\s]*$/,
                              message: "Owner name can only contain letters and spaces",
                            }
                          ]}
                        >
                          <Input placeholder='John' />
                        </Form.Item>
                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='Franchise Location'
                          name='location'
                          className="form-item-alignment"
                          rules={[
                            {
                              required: true,
                              message: "Please input Location!",
                            },
                            {
                              pattern: /^[^\s].*[^\s]$/,
                              message: "Location cannot start or end with spaces",
                            }
                          ]}
                        >
                          <Input
                            placeholder='Pune - Koregaon Park'
                            style={{ width: "100%" }}
                          />
                        </Form.Item>
                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='Franchise Support Phone'
                          name='phoneNumber'
                          className="form-item-alignment"
                          rules={[
                            {
                              required: true,
                              message: "Please input Phone Number!",
                            },
                            {
                              pattern: /^\+?[0-9]{10,15}$/,
                              message: "Please enter a valid phone number (10-15 digits)",
                            }
                          ]}
                        >
                          <Input placeholder='+91 9098909890' />
                        </Form.Item>
                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='Franchise status'
                          name='franchiseStatus'
                          className="form-item-alignment franchise-sts"
                        >
                          <Select
                            placeholder='Select Franchise Status'
                            allowClear
                            mode='single'
                            size='middle'
                            style={{
                              width: "100%",
                            }}
                          >
                            <Option value="Active">Active</Option>
                            <Option value="Inactive">Inactive</Option>
                            <Option value="Upcoming">Upcoming</Option>
                          </Select>
                        </Form.Item>
                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='User Name'
                          name='userName'
                          className="form-item-alignment"
                          rules={[
                            {
                              required: true,
                              message: "Please input User Name!",
                            },
                            {
                              pattern: /^[a-zA-Z0-9_]+$/,
                              message: "Username can only contain letters, numbers, and underscores",
                            },
                            {
                              min: 3,
                              message: "Username must be at least 3 characters",
                            }
                          ]}
                        >
                          <Input placeholder='Franchise_john' />
                        </Form.Item>
                      </Col>

                      <Col xs={24} lg={12} className='gutter-row'>
                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='Franchise Address'
                          name='address'
                          className="form-item-alignment"
                          rules={[
                            {
                              required: true,
                              message: "Please input Address!",
                            },
                            {
                              pattern: /^[^\s].*[^\s]$/,
                              message: "Address cannot start or end with spaces",
                            }
                          ]}
                        >
                          <TextArea
                            placeholder='Pune - Koregaon Park'
                            style={{ width: "100%", height: 120 }}
                          />
                        </Form.Item>

                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='Franchise Support Email'
                          name='email'
                          className="form-item-alignment"
                          rules={[
                            {
                              required: true,
                              message: "Please input email!",
                            },
                            {
                              type: 'email',
                              message: "Please enter a valid email address",
                            }
                          ]}
                        >
                          <Input placeholder='franchisejohn@example.com' />
                        </Form.Item>
                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='Maximum Number of Players'
                          className="form-item-alignment"
                          name='maxPlayers'
                          rules={[
                            {
                              required: true,
                              message: "Please input Maximum Number of Players!"
                            },
                            {
                              pattern: /^[0-9]+$/,
                              message: "Max Players should only contain numbers",
                            }
                          ]}
                        >
                          <Input placeholder='12' />
                        </Form.Item>
                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='Franchise Image'
                          className="form-item-alignment upload-input"
                          name='franchiseImage'
                          rules={[{ required: true, message: "Please Upload Franchise Image! (540 X 360)" }]}
                        >
                          <div>
                            <Upload
                              accept="image/*"
                              showUploadList={false}
                              beforeUpload={(file) => {
                                const reader = new FileReader();
                                reader.onload = (e) => {
                                  setImageUrl(e.target.result);
                                  setShowCropper(true);
                                };
                                reader.readAsDataURL(file);
                                return false;
                              }}
                            >
                              <Button className="!text-black hover:!text-black focus:!text-black focus:shadow-none hover:!border-[#d9d9d9] focus:!border-[#d9d9d9] !w-full !h-11 flex items-center justify-center" icon={<div className="m-1"><UploadOutlined /></div>}>Click to Upload Image</Button>
                            </Upload>
                            {imageUrl && (
                              <div className="mt-2">
                                <img src={imageUrl} alt="Uploaded Image" className="mt-2"
                                  style={{ maxHeight: "360px" }} />
                              </div>
                            )}
                            <p className="text-danger mt-1">* Upload image size 540 x 360 pixels</p>
                          </div>
                        </Form.Item>

                      </Col>
                    </Row>


                  </Col>
                  <Col span={24} className='gutter-row'>
                    <h2 className='text-xl mt-3 mb-5 text-danger hover:text-dangerHover font-semibold'>
                      <span className="pb-1 border-b-2 border-danger inline-block">
                        Payment & SEO Information{" "}
                      </span>
                    </h2>

                    <Row
                      gutter={{
                        xs: 8,
                        sm: 16,
                        md: 24,
                        lg: 32,
                      }}
                    >
                      <Col xs={24} lg={12} className='gutter-row'>
                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='Name of Company'
                          name='companyName'
                          className="form-item-alignment"
                          rules={[
                            {
                              pattern: /^[^\s].*[^\s]$/,
                              message: "Company name cannot start or end with spaces",
                            }
                          ]}
                        >
                          <Input placeholder='Name of Company' />
                        </Form.Item>
                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='CSGT Number'
                          name='cgstNumber'
                          className="form-item-alignment"
                          rules={[
                            {
                              pattern: /^[0-9]{15}$/,
                              message: "CGST number must be 15 digits",
                            }
                          ]}
                        >
                          <Input placeholder='CSGT Number' />
                        </Form.Item>
                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='CSGT (%)'
                          name='cgstValue'
                          className="form-item-alignment"
                          rules={[
                            {
                              pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                              message: "CGST must be a valid float number",
                            }
                          ]}
                        >
                          <Input placeholder='CSGT' />
                        </Form.Item>
                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='Google Maps iframe'
                          name='mapIframe'
                          className="form-item-alignment"
                          rules={[{ required: true, message: "Please input Google Maps iframe!" }]}
                        >
                          <TextArea placeholder='Google Maps iframe' style={{ height: 120 }} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} lg={12} className='gutter-row'>
                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='Easebuzz Submerchant Id'
                          name='merchantId'
                          className="form-item-alignment"
                          rules={[
                            {
                              pattern: /^[^\s].*[^\s]$/,
                              message: "Merchant ID cannot start or end with spaces",
                            }
                          ]}
                        >
                          <Input placeholder='Easebuzz Submerchant Id' />
                        </Form.Item>
                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='SGST Number'
                          name='sgstNumber'
                          className="form-item-alignment"
                          rules={[
                            {
                              pattern: /^[0-9]{15}$/,
                              message: "SGST number must be 15 digits",
                            }
                          ]}
                        >
                          <Input placeholder='SGST Number' />
                        </Form.Item>
                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='SGST (%)'
                          name='sgstValue'
                          className="form-item-alignment"
                          rules={[
                            {
                              pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                              message: "SGST must be a valid float number",
                            }
                          ]}
                        >
                          <Input placeholder='SGST' />
                        </Form.Item>

                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row
                  gutter={{
                    xs: 8,
                    sm: 16,
                    md: 24,
                    lg: 32,
                  }}
                >
                  <Col span={24} className='gutter-row'>
                    <h2 className='text-xl mt-3 mb-5 text-danger hover:text-dangerHover font-semibold'>
                      <span className="pb-1 border-b-2 border-danger inline-block">
                        Social Information
                      </span>
                    </h2>
                    <Row
                      gutter={{
                        xs: 8,
                        sm: 16,
                        md: 24,
                        lg: 32,
                      }}
                    >
                      <Col xs={24} lg={12} className='gutter-row'>
                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='Facebook Link'
                          name='facebookLink'
                          className="form-item-alignment"
                          rules={[
                            {
                              type: 'url',
                              message: "Please enter a valid Facebook URL",
                            }
                          ]}
                        >
                          <Input placeholder='Facebook Link' />
                        </Form.Item>
                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='Instagram Link'
                          name='instagramLink'
                          className="form-item-alignment"
                          rules={[
                            {
                              type: 'url',
                              message: "Please enter a valid Instagram URL",
                            }
                          ]}
                        >
                          <Input placeholder='Instagram Link' />
                        </Form.Item>
                      </Col>
                      <Col xs={24} lg={12} className='gutter-row'>
                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='Youtube Link'
                          name='youtubeLink'
                          className="form-item-alignment"
                          rules={[
                            {
                              type: 'url',
                              message: "Please enter a valid Youtube URL",
                            }
                          ]}
                        >
                          <Input placeholder='Youtube link' />
                        </Form.Item>

                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='Google+ Link'
                          name='googleLink'
                          className="form-item-alignment"
                          rules={[
                            {
                              type: 'url',
                              message: "Please enter a valid Google link URL",
                            }
                          ]}
                        >
                          <Input placeholder='Google+ Link' />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row
                  gutter={{
                    xs: 8,
                    sm: 16,
                    md: 24,
                    lg: 32,
                  }}
                >
                  <Col span={24} className='gutter-row'>
                    <h2 className='text-xl mt-3 mb-5 text-danger hover:text-dangerHover font-semibold'>
                      <span className="pb-1 border-b-2 border-danger inline-block">
                        SEO Information
                      </span>
                    </h2>
                    <Row
                      gutter={{
                        xs: 8,
                        sm: 16,
                        md: 24,
                        lg: 32,
                      }}
                    >
                      <Col xs={24} lg={12} className='gutter-row'>
                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='SEO Title'
                          name='seoTitle'
                          className="form-item-alignment"
                        >
                          <Input placeholder='SEO Title' />
                        </Form.Item>
                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='SEO Meta'
                          name='seoMeta'
                          className="form-item-alignment"
                        >
                          <Input placeholder='SEO Meta' />
                        </Form.Item>
                      </Col>
                      <Col xs={24} lg={12} className='gutter-row'>
                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='SEO Description'
                          name='seoDescription'
                          className="form-item-alignment"
                        >
                          <Input placeholder='SEO Description' />
                        </Form.Item>
                        <Form.Item
                          style={{ marginBottom: "16px" }}
                          label='SEO Footer'
                          name='seoFooter'
                          className="form-item-alignment"
                        >
                          <Input placeholder='SEO Footer' />
                        </Form.Item>
                      </Col>

                    </Row>
                  </Col>
                </Row>
                <Row
                  gutter={{
                    xs: 8,
                    sm: 16,
                    md: 24,
                    lg: 32,
                  }}
                >
                  <Col span={24} className='gutter-row'>
                    <h2 className='text-xl mt-3 mb-5 text-danger hover:text-dangerHover font-semibold'>
                      <span className="pb-1 border-b-2 border-danger inline-block">
                        Days & Time Settings
                      </span>
                    </h2>
                    <Row
                      gutter={{
                        xs: 8,
                        sm: 16,
                        md: 24,
                        lg: 32,
                      }}
                      className="franchise-days-section"
                    >
                      <Col xs={24} lg={8} className='gutter-row'>
                        <Form.Item label="Weekdays" name="weekDays" className="form-item-alignment"
                          rules={[
                            {
                              required: true,
                              message: "Please select Weekdays!",
                            },
                          ]}>
                          <Select
                            mode="multiple"
                            value={weekDays}
                            onChange={handleWeekDaysSelectChange}
                            placeholder="Select days"
                            style={{ width: "100%" }}

                          >
                            {daysOfWeek.map((day) => (
                              <Option key={day} value={day}>
                                {day}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} lg={8} className='gutter-row'>
                        <Form.Item label="Weekend days" name="weekendDays" className="form-item-alignment"
                          rules={[
                            {
                              required: true,
                              message: "Please select Weekend days!",
                            },
                          ]}>
                          <Select
                            mode="multiple"
                            value={weekEndDays}
                            onChange={handleWeekEndDaysSelectChange}
                            placeholder="Select days"
                            style={{ width: "100%" }}
                            disabled={weekDays.length === 0} // Disable if no selection in the first dropdown
                          >
                            {getRemainingDays(weekDays).map((day) => (
                              <Option key={day} value={day}>
                                {day}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} lg={8} className='gutter-row'>
                        <Form.Item label="Weekly Off" name="weekOffDay" className="form-item-alignment">
                          <Select
                            mode="multiple"
                            value={weekOffDays}
                            onChange={handleWeekOffDaysSelectChange}
                            placeholder="Select days"
                            style={{ width: "100%" }}
                            disabled={weekEndDays.length === 0} // Disable if no selection in the second dropdown
                          >
                            {getRemainingDays([...weekDays, ...weekEndDays]).map((day) => (
                              <Option key={day} value={day}>
                                {day}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row
                      gutter={{
                        xs: 8,
                        sm: 16,
                        md: 24,
                        lg: 32,
                      }}
                      className="franchise-days-section"
                    >
                      <Col xs={24} lg={8}>
                        <Form.Item label="Franchise Weekdays Time"
                          name="franchiseTime"
                          className="form-item-alignment">
                          
                          <div style={{ display: 'flex', gap: '10px' }} className="time-wrapper">
                            <TimePicker
                              value={openTime}
                              onChange={handleStartTimeChange}
                              format="hh:mm A"
                              className="start-time"
                              id="start-time"
                              placeholder=" Start time"
                              use12Hours
                            />
                            <TimePicker
                              value={closeTime}
                              onChange={handleEndTimeChange}
                              format="hh:mm A"
                              className="end-time"
                              id="end-time"
                              placeholder=" End time"
                              use12Hours
                            />
                          </div>
                        </Form.Item>
                      </Col>
                      
                      <Col xs={24} lg={8}>
                        <Form.Item label="Franchise Weekend Time"
                          name="weeekEndFranchiseTime"
                          className="form-item-alignment">
                          <div style={{ display: 'flex', gap: '10px' }} className="time-wrapper">
                            <TimePicker
                              value={weekendOpenTime}
                              onChange={handleWeekendOpenTimeChange}
                              format="hh:mm A"
                              className="start-time"
                              id="start-time"
                              placeholder=" Start time"
                              use12Hours
                            />
                            <TimePicker
                              value={weekendCloseTime}
                              onChange={handleWeekendCloseTimeChange}
                              format="hh:mm A"
                              className="end-time"
                              id="end-time"
                              placeholder=" End time"
                              use12Hours
                            />
                          </div>
                        </Form.Item>
                      </Col>
                      <Col xs={24} lg={8}>
                        <Form.Item label="Franchise Holiday" className="form-item-alignment">
                          {/* RangePicker inside Form.Item */}
                          <div className="flex flex-col gap-2">
                            <DatePicker.RangePicker
                              value={holidayDates ? [dayjs(holidayDates[0]), dayjs(holidayDates[1])] : null}
                              onChange={(val) => {
                                setHolidayDates(val ? val.map(date => date.format('YYYY-MM-DD')) : null)
                              }}
                              disabledDate={(current) => {
                                return current && current < dayjs().startOf('day');
                              }}
                              format="DD-MM-YYYY"
                              style={{ width: "100%" }}
                              disabled={!isEditing}
                              className="date-picker"
                            />
                          </div>
                        </Form.Item>
                      </Col>
                    </Row>


                  </Col>
                </Row>
                <div className="flex justify-end gap-3 items-center">
                  {isEditing && <Form.Item
                    wrapperCol={{ span: 24 }}
                  >
                    {isEditing && <Button
                      className='btn-primary border-none w-max'
                      size='large'
                      block
                      shape='round'
                      onClick={async () => {
                        try {
                          setIsSavingForm(true);
                          checkHolidayChanges();
                          await onFinish(() => {
                            setIsSavingForm(false);
                          });
                          setIsSavingForm(false);
                        } catch (error) {
                          console.error("error in saving form :: ", error)
                        } finally {
                          setIsSavingForm(false);
                        }

                      }}
                      loading={isSavingForm}
                      disabled={isSavingForm || isSubmittingForm}
                    >
                      Save
                    </Button>}
                  </Form.Item>}

                  <Form.Item
                    wrapperCol={{
                      span: 24,
                    }}
                    className="flex justify-end"
                  >
                    <Button
                      className='btn-primary border-none w-max'
                      size='large'
                      htmlType="button"
                      block
                      shape='round'
                      loading={isSubmittingForm}
                      disabled={isSubmittingForm || isSavingForm}
                      onClick={isEditing ? async () => {
                        try {
                          setIsSubmittingForm(true);
                          checkHolidayChanges();
                          await onFinish(() => {
                            setCurrent(current + 1);
                            setIsSubmittingForm(false);
                          });
                          setIsSubmittingForm(false);
                        } catch (error) {
                          console.error("error in saving form :: ", error)
                        } finally {
                          setIsSubmittingForm(false);
                        }

                      } : handleNext}
                    >
                      Save & Next
                    </Button>
                  </Form.Item>
                </div>

              </>}
            {showCropper && imageUrl && (
              <ImageCropper
                imageUrl={imageUrl}
                crop={crop}
                zoom={zoom}
                aspect={3 / 2}
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={onCropComplete}
                onClose={() => {
                  setShowCropper(false);
                  if (isEditing) {
                    // If editing, restore the original image
                    setImageUrl(originalImageUrl);
                  } else {
                    // If creating new, clear the image
                    setImageUrl('');
                    setImage(null);
                    form.setFieldsValue({ franchiseImage: undefined });
                  }
                }}
                onCrop={cropImage}
              />
            )}
          </div>
        )}
        {current === 1 && (
          <div className='mr-top mb-4 px-6 pb-6 pt-4 ant-card franchise-second-step border-radius-bottom' style={{ maxWidth: "100%" }}>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col span={20} className='gutter-row form-color'>
                <h2 className='flex justify-start text-xl mt-3 mb-5 text-danger hover:text-dangerHover font-semibold'>
                  <span className="pb-1 border-b-2 border-danger inline-block"> Select Games </span>
                </h2>
              </Col>
            </Row>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col span={24} className='gutter-row form-color'>
                <Form.Item
                  style={{ marginBottom: "10px" }}
                  name='productId'
                  rules={[{ required: true, message: "Please select at least one game" }]}
                >
                  <Checkbox.Group style={{ width: "100%" }}>
                    <Row gutter={[16, 16]}>
                      {gamesData?.map((game) => (
                        <Col key={game.id} xs={24} sm={12} md={8}>
                          <Checkbox value={game.id}>{game.gameName}</Checkbox>
                        </Col>
                      ))}
                    </Row>
                  </Checkbox.Group>
                </Form.Item>
              </Col>
            </Row>

            <div className="flex justify-end gap-3 mt-5">
              {isEditing && <Form.Item
                style={{ marginBottom: "10px" }}
                wrapperCol={{ span: 24 }}
              >
                <Button
                  className='btn-primary border-none w-max'
                  size='large'
                  block
                  shape='round'
                  onClick={async () => {
                    try {
                      setIsSavingForm(true);
                      await onFinish(() => {
                        setIsSavingForm(false);
                      });
                      setIsSavingForm(false);
                    } catch (error) {
                      console.error("error in saving form :: ", error)
                    } finally {
                      setIsSavingForm(false);
                    }
                  }}
                  loading={isSavingForm}
                  disabled={isSavingForm || isSubmittingForm}
                >
                  Save
                </Button>
              </Form.Item>}

              <Form.Item
                style={{ marginBottom: "10px" }}
                wrapperCol={{ span: 24 }}
              >
                <Button
                  className='btn-primary border-none w-max'
                  size='large'
                  block
                  shape='round'
                  loading={isSubmittingForm}
                  disabled={isSubmittingForm || isSavingForm}
                  onClick={async () => {
                    try {
                      setIsSubmittingForm(true);
                      await onFinish(() => {
                        setCurrent(current + 1);
                        setIsSubmittingForm(false);
                      });
                      setIsSubmittingForm(false);
                    } catch (error) {
                      console.error("error in saving form :: ", error)
                    } finally {
                      setIsSubmittingForm(false);
                    }
                  }}
                >
                  Save & Next
                </Button>
              </Form.Item>
            </div>
          </div>
        )}
      </Form >
    </>
  )
}

export default FranchiseForm